import React, { useEffect, useState } from "react";
import { IconClipboard } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { LangConstant, SystemConstant } from "const";
import { useCreateDepartment, useEditDepartment } from "hooks";
import { CommonUtils, SystemUtils, UnitUtils } from "utils";

const DepartmentDialog = ({ open, unitList, selectedUnit, selectedDepartment, onClose }) => {
  const isEdit = selectedUnit === null && Boolean(selectedDepartment);
  const { t: getLabel } = useTranslation();
  const departmentDetail = getLabel(LangConstant.OBJ_DEPARTMENT_DETAIL, { returnObjects: true });
  const departmentError = getLabel(LangConstant.OBJ_DEPARTMENT_ERROR, { returnObjects: true });
  const { createDepartment } = useCreateDepartment();
  const { editDepartment } = useEditDepartment();

  const [departmentForm, setDepartmentForm] = useState({
    name: selectedDepartment?.departmentName || "",
    selectedUnitId: selectedUnit?.unitId || selectedDepartment?.unitId || "",
  });

  const handleChangeDepartmentForm = event => {
    if (event.target.name === "name") {
      setDepartmentForm(currentState => ({
        ...currentState,
        [event.target.name]: CommonUtils.capitalizeFirstLetter(event.target.value),
      }));
    } else {
      setDepartmentForm(currentState => ({
        ...currentState,
        [event.target.name]: event.target.value,
      }));
    }
  };

  const handleSubmit = () => {
    if (!UnitUtils.isValidName(departmentForm.name)) {
      SystemUtils.appendNotification(getLabel(departmentError[SystemConstant.UNIT_ERROR.IN_WRONG_FORMAT]), "error");
    } else if (isEdit) {
      editDepartment({
        unitId: departmentForm.selectedUnitId,
        departmentName: departmentForm.name,
        departmentId: selectedDepartment.departmentId,
        onClose,
      });
    } else {
      createDepartment({
        unitId: departmentForm.selectedUnitId,
        departmentName: departmentForm.name,
        onClose,
      });
    }
  };

  useEffect(() => {
    setDepartmentForm(currentState => ({
      ...currentState,
      name: selectedDepartment?.departmentName || "",
      selectedUnitId: selectedUnit?.unitId || selectedDepartment?.unitId || "",
    }));
  }, [selectedUnit, selectedDepartment]);

  // ESC key handler
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = e => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
      <div className="modal show d-block" tabIndex="-1" style={{ zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" style={{ fontWeight: 600 }}>
                {getLabel(isEdit ? LangConstant.TXT_EDIT_DEPARTMENT : LangConstant.TXT_CREATE_DEPARTMENT)}
              </h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label" style={{ fontWeight: 600 }}>
                  {departmentDetail.name}
                </label>
                <div className="input-group">
                  <span className="input-group-text">
                    <IconClipboard size={18} />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={departmentForm?.name}
                    onChange={handleChangeDepartmentForm}
                    placeholder={getLabel(LangConstant.TXT_ENTER_DEPARTMENT_NAME)}
                  />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label" style={{ fontWeight: 600 }}>
                  {departmentDetail.unit}
                </label>
                <select
                  className="form-select"
                  name="selectedUnitId"
                  value={departmentForm.selectedUnitId}
                  onChange={handleChangeDepartmentForm}
                  disabled={isEdit}
                >
                  <option value="" disabled></option>
                  {unitList.map((row, index) => (
                    <option key={index} value={row.unitId}>
                      {row.unitName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-outline-danger"
                style={{ flex: 1 }}
                onClick={onClose}
              >
                {getLabel(LangConstant.L_CANCEL_ADD_BRANCH)}
              </button>
              <button
                className="btn btn-primary"
                style={{ flex: 1, marginLeft: 12 }}
                onClick={handleSubmit}
              >
                {getLabel(isEdit ? LangConstant.L_CONFIRM_BUTTON : LangConstant.L_CREATE)}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepartmentDialog;
